import { MediaQuery } from "typestyle/lib/types";

const mediaQueries = {
  mobile: { maxWidth: 500 },
  tablet: { minWidth: 501, maxWidth: 800 },
  desktopSmall: { minWidth: 801, maxWidth: 1100 },
  desktopLarge: { minWidth: 1101 },
};

export const upTo = (query: MediaQuery): MediaQuery => ({ maxWidth: query.maxWidth || 99999 });
export const upFrom = (query: MediaQuery): MediaQuery => ({ minWidth: query.minWidth || 0 });
export const between = (low: MediaQuery, high: MediaQuery): MediaQuery => ({
  minWidth: low.minWidth,
  maxWidth: high.maxWidth,
});

export default mediaQueries;
